import { Injectable } from '@angular/core';
import {HttpCommonService} from "./http-common.service";
import {GlobalService} from "./global.service";

@Injectable()
export class CaptchaService {

  constructor(private globalService: GlobalService, public httpService: HttpCommonService) { }

  generateCaptcha(type?: any) {
    let preUrl = "/auth/captcha.jpg";
    if (this.globalService.getValue("JessionID")) {
      return this.httpService.getBaseUrl() + preUrl + "?JessionID=" + this.globalService.getValue("JessionID") + "&"+ Math.random();
    } else {
      let uuid = this.globalService.uuid();
      this.globalService.setKey("JessionID", uuid);
      return this.httpService.getBaseUrl() + preUrl + "?JessionID=" + uuid + "&"+ Math.random();
    }
  }

  // 更换验证码
  changeCap(type?: any) {
    $("nz-input[formcontrolname='captcha'] input").val("");
    $(".captcha").attr("src", this.generateCaptcha(type) + "&"+ Math.random());
  }
}



// WEBPACK FOOTER //
// E:/java/gd-project/credit-gd-web/src/app/services/captcha.service.ts